import initialValues from './initialValues';
import { getRoutesFromLocalStorage } from '@ott/search-history';

import isEqual from 'lodash/isEqual';

const checkConsistency = ({ from, to, dates }) =>
  dates && from && to && from.id && to.id && from.country && to.country && from.trans && to.trans;

export function checkSearchHistory(routes, newRoute) {
  const now = Date.now();
  // eslint-disable-next-line no-param-reassign
  routes = routes || [];

  // при сохранении нового роута проверяем наличие аналогичных и отфильтровываем их
  if (newRoute) {
    const newRouteInfo = {
      from: newRoute.route.from.id,
      to: newRoute.route.to.id,
      dates: {
        startDate: newRoute.route.dates.startDate.toISOString(),
      },
    };

    if (newRoute.route.dates.endDate) {
      newRouteInfo.dates.endDate = newRoute.route.dates.endDate.toISOString();
    } else {
      // eslint-disable-next-line no-param-reassign
      delete newRoute.route.dates.endDate;
    }

    // eslint-disable-next-line no-param-reassign
    routes = routes.filter(
      (route) =>
        !isEqual(newRouteInfo, {
          from: route.route.from.id,
          to: route.route.to.id,
          dates: route.route.dates,
        })
    );
  }

  return routes
    .map((route) => {
      if (!route || !checkConsistency(route.route || {})) {
        return null;
      }

      try {
        const {
          route: { dates },
        } = route;

        const startDate = new Date(dates.startDate);
        const endDate = dates.endDate && new Date(dates.endDate);

        if (startDate.getTime() < now) {
          return null;
        }

        return {
          route: {
            ...initialValues.route,
            ...route.route,
            dates: {
              startDate,
              endDate,
            },
          },
          query: {
            ...initialValues.query,
            ...route.query,
          },
        };
      } catch (e) {
        return null;
      }
    })
    .filter(Boolean);
}

export function getLastSearch() {
  const [lastSearch] =
    getRoutesFromLocalStorage('railwaysHistoryRoutes', 0, checkSearchHistory) || [];

  const data = lastSearch || initialValues;
  const dates = data.route.dates || {};

  return {
    ...data.route,
    ...data.query,
    roundTrip: Boolean(dates.startDate && dates.endDate),
  };
}
